import { ContentListPage } from '../components/ContentListPage';
import { ArticleContent } from '../components/article/ArticleBlockRenderer';
import { buildCursorMcpInstallUrl } from '../../../shared/lib/cursorMcpInstall';
import { resolveMcpServerUrl } from '../../../shared/lib/publicApiUrl';
import { MCP_PAGE_CONTENT, MCP_PAGE_INTRO, MCP_PAGE_TITLE } from '../constants/mcpPage';
import { track } from '../lib/posthog';

const MCP_URL = resolveMcpServerUrl(import.meta.env.VITE_API_BASE);
const MCP_CLIENT_ID = import.meta.env.VITE_MCP_OAUTH_CLIENT_ID || 'arvid-cursor-mcp';

const INSTALL_URL = buildCursorMcpInstallUrl({
  mcpUrl: MCP_URL,
  clientId: MCP_CLIENT_ID,
});

function handleAddToCursorClick() {
  track('mcp_add_to_cursor_clicked');
}

export function McpPage() {
  return (
    <ContentListPage title="">
      <div className="col-span-full flex justify-center">
        <div className="flex w-full max-w-article-content flex-col gap-10">
          <div className="flex flex-col gap-6">
            <h1 className="text-h2 text-text-primary">{MCP_PAGE_TITLE}</h1>
            <p className="text-body-lg text-text-tertiary">{MCP_PAGE_INTRO}</p>
          </div>

          <a
            href={INSTALL_URL}
            className="site-btn-primary site-btn-lg"
            onClick={handleAddToCursorClick}
          >
            <img src="/cursor.svg" alt="" className="size-[18px] shrink-0 brightness-0" />
            Add to Cursor
          </a>

          <ArticleContent content={MCP_PAGE_CONTENT} />
        </div>
      </div>
    </ContentListPage>
  );
}
